import { style } from '@angular/animations';
import {
  Chat,
  Coupon,
  MapMarker,
  Media,
  Menu,
  Page,
  Product,
  ProductImage,
  ProductOption,
  ProductStore,
  SignupPatternUI,
  Smtp,
  ThirdPartyInfoUI,
  UIAttribute,
} from "./interface";

export class GetUpgradedChatList {
  readonly method = "getUpgradedChatList";
  constructor(public ref: string) {}
}
export class SelectChat {
  readonly method = "selectChat";
  constructor(
    public chat_id: string,
    public isAuth: number,
    public ref: string
  ) {}
}

export class CreateChat {
  readonly method = "createChat";
  constructor(public chat: Chat, public ref: string) {}
}
export class SetChat {
  readonly method = "setChat";
  constructor(public chat: Chat, public reference?: string) {}
}
export class listChat {
  readonly method = "listChats";
  readonly page_size = 24;
  constructor(
    public type: string,
    public page_number: number,
    public chat_id: string,
    public ref: string,
    public group_id?: string,
    public name?: string,
    public created_date?: any
  ) {}
}

export class getChat {
  readonly method = "getChat";
  readonly p = 1;
  constructor(public chat_id: string, public reference: string) {}
}
export class DeleteGroup {
  readonly method = "deleteGroup";
  constructor(public group_id: string, public ref: string) {}
}

export class GetBookingExceptions {
  readonly method = "getBookingExceptions";
  constructor(
    public chat_id: string,
    public date: string,
    public reference: string
  ) {}
}
export class GetBookingPeriods {
  readonly method = "getBookingPeriods";
  constructor(public chat_id: string, public reference: string) {}
}
export class SetBookingPeriods {
  readonly method = "setBookingPeriods";
  constructor(
    public chat_id: string,
    public data: any[],
    public reference: string
  ) {}
}
export class RemoveBookingPeriods {
  readonly method = "removeBookingPeriods";
  constructor(
    public chat_id: string,
    public data: any[],
    public reference: string
  ) {}
}
export class SetBookingExceptions {
  readonly method = "setBookingExceptions";
  readonly clear = 1;
  constructor(
    public chat_id: string,
    public data: string[],
    public reference: string
  ) {}
}
export class GetChatList {
  readonly method = "getChatList";
  constructor(public ref: string) {}
}

export class GetMessageList {
  readonly method = "getMsgList";
  readonly page_size = 50;
  constructor(
    public chat_id: string,
    public recent: number,
    public ref: any,
    public message_id?: string,
    public reply_to_message_id?: string,
    public date?: string,
    public admin?: any,
    public seen?: any,
    public from_user_id?: any,
    public to_user_id?: any,
    public scheduled?: number,
    public user_id?: string,
    public award?: number,
    public max_gmid?: number,
    public min_gmid?: number,
    public page_number?: number,
    public tags?: string
  ) {}
}
export class GetMsgListLevel1 {
  readonly method = "getMsgListLevel1";
  readonly page_size = 50;
  constructor(
    public chat_id: string,
    public pid: string,
    public all: number,
    public ref: any
  ) {}
}
export class GetMsgMax {
  readonly method = "getMsgMax";
  constructor(public chat_ids: string[], public ref: any) {}
}

export class SendMessage {
  readonly method = "sendMessage";
  readonly echo = 1;
  readonly web = 1;
  constructor(
    public chat_id: string,
    public text: string,
    public reference: number,
    public bg_color?: string,
    public schedule_date?: number,
    public tab?: string,
    public tags?: string[],
    public web_page_preview?: number,
    public reply_to_message_id?: string,
    public to_user_id?: string,
    public c_code?: string,
    public c_exp?: number,
    public inline_menu?: any[],
    public menu_ref?: string,
    public sticky_title?: string,
    public sticky_desc?: string,
    public chat_settings?: number
  ) {}
}
export class LikeMessage {
  readonly method = "likeMessage";
  readonly echo = 1;
  constructor(
    public chat_id: string,
    public message_id: string,
    public myLike: number
  ) {}
}
export class getChatCounters {
  readonly method = "getChatCounters";
  constructor(public chat_id: string, public message_ids: string[]) {}
}
export class SendCalendar {
  readonly method = "sendCalendar";
  readonly echo = 1;
  constructor(
    public chat_id: string,
    public calendar_id: string,
    public auto_accept: number,
    public title: string,
    public description: string,
    public photo: string,
    public json: any,
    public reference: number,
    public tab?: string,
    public tags?: string[],
    public web_page_preview?: number,
    public reply_to_message_id?: string,
    public to_user_id?: string,
    public c_code?: string,
    public c_exp?: number,
    public schedule_date?: number,
    public inline_menu?: any[],
    public menu_ref?: string
  ) {}
}
export class SendPhoto {
  readonly method = "sendPhoto";
  readonly echo = 1;
  readonly web = 1;
  constructor(
    public chat_id: string,
    public photo: string,
    public height: number,
    public width: number,
    public size: number,
    public reference: number,
    public caption?: string,
    public style?: number,
    public tab?: string,
    public tags?: string[],
    public reply_to_message_id?: string,
    public to_user_id?: string,
    public c_code?: string,
    public c_exp?: number,
    public schedule_date?: number,
    public inline_menu?: any[],
    public menu_ref?: string,
    public sticky_title?: string,
    public sticky_desc?: string,
    public chat_settings?: number
  ) {}
}
export class SendVideo {
  readonly method = "sendVideo";
  readonly echo = 1;
  readonly web = 1;
  constructor(
    public chat_id: string,
    public video: string,
    public duration: number,
    public height: number,
    public width: number,
    public size: number,
    public reference: number,
    public caption?: string,
    public tab?: string,
    public tags?: string[],
    public reply_to_message_id?: string,
    public to_user_id?: string,
    public c_code?: string,
    public c_exp?: number,
    public schedule_date?: number,
    public inline_menu?: any[],
    public menu_ref?: string,
    public sticky_title?: string,
    public sticky_desc?: string,
    public chat_settings?: number
  ) {}
}
export class SendAudio {
  readonly method = "sendAudio";
  readonly echo = 1;
  readonly web = 1;
  constructor(
    public chat_id: string,
    public audio: string,
    public duration: number,
    public size: number,
    public title: string,
    public reference: number,
    public caption?: string,
    public tab?: string,
    public tags?: string[],
    public reply_to_message_id?: string,
    public to_user_id?: string,
    public c_code?: string,
    public c_exp?: number,
    public schedule_date?: number,
    public inline_menu?: any[],
    public menu_ref?: string,
    public chat_settings?: number
  ) {}
}
export class SendDocument {
  readonly method = "sendDocument";
  readonly echo = 1;
  readonly web = 1;
  constructor(
    public chat_id: string,
    public document: string,
    public size: number,
    public reference: number,
    public tab?: string,
    public tags?: string[],
    public reply_to_message_id?: string,
    public to_user_id?: string,
    public c_code?: string,
    public c_exp?: number,
    public schedule_date?: number,
    public inline_menu?: any[],
    public menu_ref?: string,
    public chat_settings?: number
  ) {}
}
export class RecallMessage {
  readonly method = "recallMessage";
  constructor(
    public chat_id: string,
    public message_id: string,
    public reference: number,
    public reply_to_user_id?: string,
    public to_admin?: number,
    public reply_to_message_id?: string
  ) {}
}
export class listChatTags {
  readonly method = "listChatTags";
  readonly page_size = 50;
  constructor(
    public page_number: number,
    public chat_id: string,
    public ref: string
  ) {}
}

export class GetChatTags {
  readonly method = "getChatTags";
  constructor(public chat_id: string) {}
}

export class SetTags {
  readonly method = "addChatTag";
  constructor(
    public name: string,
    public description: string,
    public isPrivate: number,
    public chat_id: string,
    public ref: string,
    public id?: string
  ) {}
}
export class ListStore {
  readonly method = "listStore";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public chat_id: string,
    public ref: string,
    public collection_id?: string,
    public name?: string,
    public created_date?: any,
    public category?: string[]
  ) {}
}
export class ListProductItem {
  readonly method = "listProductItem";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public chat_id: string,
    public ref: string,
    public product_id?: string,
    public name?: string,
    public created_date?: any,
    public status?: string,
    public category?: string[],
    public vendor_id?: string
  ) {}
}
export class ListCollectionItem {
  readonly method = "listCollectionItem";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public chat_id: string,
    public ref: string,
    public collection_id?: string,
    public name?: string,
    public created_date?: any,
    public category?: string[]
  ) {}
}
export class ListPaymentOrders {
  readonly method = "listPaymentOrders";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public group_id: string,
    public ref: string,
    public created_date?: any
  ) {}
}
export class ListUserCoupons {
  readonly method = "listUserCoupons";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public chat_id: string,
    public ref: string,
    public coupon_id?: string,
    public name?: string,
    public created_date?: any,
    public status?: string,
    public expire?: any
  ) {}
}

export class GetCampaignList {
  readonly method = "getCampaignList";
  readonly page_size = 24;
  constructor(public page_number: number, public ref: string) {}
}

export class GetAppConfig {
  readonly method = "getAppConfig";
  constructor(
    public reference: string,
    public genAI?: boolean,
    public restore?: boolean
  ) {}
}

export class ListUsers {
  readonly method = "listUsers";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public chat_id: string,
    public ref: string,
    public member_id?: string,
    public member_list?: string[],
    public name?: string,
    public msisdn?: string,
    public status?: string,
    public role_id?: number,
    public created_date?: any
  ) {}
}

export class BanMemberFromChat {
  readonly method = "banChatMember";
  constructor(
    public chat_id: string,
    public user_id: string,
    public ref: string
  ) {}
}
export class UnBanMemberFromChat {
  readonly method = "unbanChatMember";
  constructor(
    public chat_id: string,
    public user_id: string,
    public ref: string
  ) {}
}
export class PromoteChatMember {
  readonly method = "promoteChatMember";
  constructor(
    public chat_id: string,
    public user_id: string,
    public ref: string
  ) {}
}

export class RemoveMemberFromChat {
  readonly method = "removeChatMember";
  constructor(
    public chat_id: string,
    public user_id: string,
    public ref: string
  ) {}
}

export class GetWhitelistUsers {
  readonly method = "getWhitelistUsers";
  readonly page_size = 25;
  constructor(
    public page_number: number,
    public chat_id: string,
    public reference: string,
    public msisdn?: string
  ) {}
}

export class GetBlacklistUsers {
  readonly method = "getBlacklistUsers";
  readonly page_size = 25;
  constructor(
    public page_number: number,
    public chat_id: string,
    public reference: string,
    public msisdn?: string
  ) {}
}

export class ListMenus {
  readonly method = "listMenus";
  readonly page_size = 25;
  constructor(
    public page_number: number,
    public chat_id: string,
    public ref: string,
    public menu_id?: string,
    public name?: string,
    public status?: string,
    public created_date?: any
  ) {}
}

export class GetMenuPage {
  readonly method = "getMenuPage";
  constructor(public ref: string) {}
}

export class SetMenuPage {
  readonly method = "setMenuPage";
  constructor(public page: any, public reference: string) {}
}

export class CreateMyPage {
  readonly method = "createMyPage";
  constructor(public page: Page) {}
}
export class SetMyPage {
  readonly method = "setMyPage";
  constructor(public page: Page) {}
}

export class GetMyGallery {
  readonly method = "getMyGallery";
  constructor(public mediaType: string) {}
}

export class DeleteMyGallery {
  readonly method = "deleteMyGallery";
  constructor(public filename: string) {}
}

export class PublishAppConfig {
  readonly method = "publishAppConfig";
  constructor(
    public version: number,
    public track: number,
    public version_name?: string,
    public version_desc?: string
  ) {}
}

export class SetAppConfig {
  readonly method = "setAppConfig";
  constructor(
    public reference: string,
    public version: number,
    public appConfig: any,
    public onlineAppConfig: any,
    public onlineChannelConfig: any,
    public confirm?: string
  ) {}
}

export class ListAppRelease {
  readonly method = "listAppRelease";
  constructor(public ref: string) {}
}
export class GetApps {
  readonly method = "getApps";
  constructor(public ref?: string) {}
}
export class GetAppStore {
  readonly method = "getAppStore";
  constructor(public ref?: string) {}
}
export class GetAppsSetup {
  readonly method = "getAppsSetup";
  constructor(public ref?: string) {}
}
export class SetupApp {
  readonly method = "setupApp";
  constructor(public app: any, public os: number) {}
}

export class GenerateApp {
  readonly method = "generateApp";
  constructor(
    public reference: string,
    public app_id: string,
    public os: number,
    public version_name?: string,
    public version_desc?: string,
    public android_format?: string
  ) {}
}

export class ListAppReleaseId {
  readonly method = "getAppRelease";
  constructor(public id: number) {}
}

export class SetAppleStore {
  readonly method = "setAppStore";
  constructor(public os: number, public app_store: any) {}
}

export class SetAppleCode {
  readonly method = "setAppleCode";
  constructor(public code: string) {}
}

export class Revoke {
  readonly method = "revoke";
  constructor(public type: string) {}
}

export class GetMyMedia {
  readonly method = "getMyMedia";
  readonly page_size = 24;
  constructor(
    public ref: string,
    public page_number: number,
    public mediaType: string,
    public chat_id: string,
    public aspectRatio?: string,
    public keyword?: string
  ) {}
}

export class SetProviderConfig {
  readonly method = "setProviderConfig";
  constructor(
    public provider_id: string,
    public config: any,
    public ref: string
  ) {}
}
export class GetProviderConfig {
  readonly method = "getProviderConfig";
  constructor(public ref: string, public provider_id?: string) {}
}
export class CreateApiToken {
  readonly method = "createApiToken";
  constructor(
    public ref: string,
    public user_id: string,
    public chat_id: string
  ) {}
}
export class GetApiToken {
  readonly method = "getApiToken";
  constructor(
    public ref: string,
    public user_id: string,
    public chat_id: string
  ) {}
}

export class ListBots {
  readonly method = "listBots";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public chat_id: string,
    public ref: string,
    public group_id?: string,
    public name?: string,
    public created_date?: any
  ) {}
}

export class GetCalendars {
  readonly method = "listCalendars";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public ref: string,
    public id?: string,
    public name?: string,
    public created_date?: any
  ) {}
}

export class CreateCalendar {
  readonly method = "createCalendar";
  constructor(
    public name: string,
    public start_date: string,
    public end_date: string,
    public data: any,
    public ref: string,
    public start_time?: string,
    public end_time?: string
  ) {}
}
export class SetCalendar {
  readonly method = "setCalendar";
  constructor(
    public id: string,
    public name: string,
    public start_date: string,
    public end_date: string,
    public data: any,
    public ref: string,
    public exceptions?: string[],
    public start_time?: string,
    public end_time?: string
  ) {}
}
export class GetCalendar {
  readonly method = "getCalendar";
  constructor(public id: string, public ref: string) {}
}
export class GetCalendarDetails {
  readonly method = "getCalendarDetails";
  constructor(public calendar_id: string, public ref: string) {}
}
export class SetCalendarDetail {
  readonly method = "setCalendarDetail";
  readonly clear = 1;
  constructor(
    public calendar_id: string,
    public ref: string,
    public data: any
  ) {}
}

export class SetProductStoreMethod {
  readonly method = "setProductItem";
  constructor(
    public id?: any,
    public name?: string,
    public service_profile_id?: number,
    public type?: number,
    public price?: number,
    public image?: ProductImage[],
    public sku?: string,
    public status?: string,
    public compare_at_price?: number,
    public option?: ProductOption[],
    public attribute?: UIAttribute,
    public tag?: any[],
    public ref?: string
  ) {}
}
export class SetProductsStoreMethod {
  readonly method = "setProductItem";
  constructor(productStore: ProductStore, public ref?: string) {
    for (const key in productStore) {
      if (productStore.hasOwnProperty(key)) {
        this[key] = productStore[key];
      }
    }
  }
}

export class SetProductItemArray {
  readonly method = "setProductItemArray";
  constructor(
    public products: ProductStore[],
    public parent_id: number,
    public type: number,
    public ref: string
  ) {}
}

export class GetProductItemMethod {
  readonly method = "getProductItem";
  constructor(public id: string, public reference: string) {}
}
export class GetStockMethod {
  readonly method = "getStock";
  constructor(public product_ids: number[], public ref: string) {}
}
export class SetStockMethod {
  readonly method = "setStock";
  constructor(public data: any[], public ref: string) {}
}
export class RemoveProductItemMethod {
  readonly method = "deleteProductElement";
  constructor(public product_id: any, public ref: string) {}
}

export class SetCollectionsToProductMethod {
  readonly method = "setProductToCollections";
  constructor(
    public product_id: number,
    public collection_id: any[],
    public ref: string
  ) {}
}

export class SetCollectionMethod {
  readonly method = "setCollectionItem";
  constructor(
    public id?: number,
    public name?: string,
    public status?: string,
    public description?: string,
    public image?: ProductImage[],
    public product_style?: string,
    public json?: any,
    public soft_id?: string,
    public product?: any[],
    public category?: string,
    public rank?: number,
    public custom_menu?: any[],
    public tag?: string[],
    public ref?: string
  ) {}
}

export class GetCollectionMethod {
  readonly method = "getCollectionItem";
  constructor(public id: number, public ref: string) {}
}

export class SetCollectionProductMethod {
  readonly method = "setCollectionProduct";
  constructor(
    public collection_id: number,
    public product_id: number[],
    public ref: string
  ) {}
}

export class DeleteCollectionElement {
  readonly method = "deleteCollectionElement";
  constructor(public collection_id: any, public ref: string) {}
}

export class SetUserCoupon {
  readonly method = "setUserCoupon";
  constructor(coupon: Coupon) {
    for (const key in coupon) {
      if (coupon.hasOwnProperty(key)) {
        this[key] = coupon[key];
      }
    }
  }
}

export class GetUser {
  readonly method = "getUser";
  readonly p = 1;
  constructor(public user_id: string, public ref: string) {}
}

export class GetMyMemberChats {
  readonly method = "getMyMemberChats";
  constructor(
    public user_id: string,
    public status: string,
    public ref: string
  ) {}
}

export class SetChatMemberTags {
  readonly method = "setChatMemberTags";
  constructor(
    public user_id: string,
    public tags: string[],
    public tag_names: string[],
    public chat_id: string,
    public ref: string
  ) {}
}

export class AddChatMember {
  readonly method = "addChatMember";
  constructor(
    public user_id: string,
    public chat_id: string,
    public ref: string
  ) {}
}
export class AddChatAdmin {
  readonly method = "addChatAdmin";
  constructor(
    public user_id: string,
    public chat_id: string,
    public ref: string
  ) {}
}
export class DemoteAdmin {
  readonly method = "demoteAdmin";
  constructor(
    public user_id: string,
    public chat_id: string,
    public ref: string
  ) {}
}
export class GetListChatTags {
  readonly method = "getListChatTags";
  constructor(public chat_id: string[], public ref: string) {}
}

export class SetRole {
  readonly method = "setRole";
  constructor(
    public user_id: string,
    public chat_id: string,
    public role: any,
    public ref: string
  ) {}
}

export class GetVerificationTemplate {
  readonly method = "getVerificationTemplate";
  constructor(public ref: string) {}
}

export class SendVerificationTemplate {
  readonly method = "setVerificationTemplate";
  constructor(public email: string, public sms: string, public ref: string) {}
}
export class ClearVerificationTemplate {
  readonly method = "clearVerificationTemplate";
  constructor(public email: boolean, public sms: boolean, public ref: string) {}
}

export class GetSmtp {
  readonly method = "getSmtp";
  constructor(public ref: string) {}
}

export class SetSmtpMethod {
  readonly method = "setSmtp";
  constructor(public smtp: Smtp, public ref: string) {}
}
export class GetMessagingVendor {
  readonly method = "getMessagingVendor";
  constructor(public name: string, public ref: string) {}
}

export class SaveThirdPartyInfoMethod {
  readonly method = "setThirdPartyInfo";
  constructor(public vendors: ThirdPartyInfoUI[], public ref: string) {}
}

export class TestThirdPartyInfoMethod {
  readonly method = "testMessagingVendor";
  constructor(public vendor: any, public ref: string) {}
}

export class SetVendor {
  readonly method = "setVendor";
  constructor(
    public id: string,
    public name: string,
    public description: string,
    public image: any,
    public ref: string,
    public vendor_id?: string,
    public wallet_id?: string
  ) {}
}

export class GetVendor {
  readonly method = "getVendor";
  constructor(public id: string, public ref: string) {}
}

export class DeleteVendor {
  readonly method = "deleteVendor";
  constructor(public id: string, public ref: string) {}
}

export class ListVendors {
  readonly method = "listVendors";
  constructor(
    public page_number: number,
    public page_size: number,
    public ref: string
  ) {}
}

export class ListGeoLocation {
  readonly method = "listGeoLocation";
  constructor(
    public page_size: number,
    public page_number: number,
    public ref: string,
    public type?: string,
    public status?: string,
    public parent_id?: string,
    public name?: string,
    public iso?: string
  ) {}
}

export class SetGeoLocation {
  readonly method = "setGeoLocation";
  constructor(
    public id?: string,
    public name?: string,
    public iso?: string,
    public parent_id?: string,
    public status?: string,
    public version?: string,
    public type?: string,
    public ref?: string
  ) {}
}

export class DeleteGeoLocation {
  readonly method = "deleteGeoLocation";
  constructor(public id: string, public ref: string) {}
}

export class GetGeoLocation {
  readonly method = "getGeoLocation";
  constructor(public id?: string, public ref?: string,public iso?: string, public type?: string) {}
}

export class SignUpDemoAccount {
  readonly method = "signUpDemoAccount";
  constructor(
    public deviceId: string,
    public os: string,
    public osVersion: string,
    public msisdn: string,
    public email: string,
    public type: string,
    public countryCode: string,
    public countryIso: string,
    public ref: string
  ) {}
}
export class RegisterDemoAccount {
  readonly method = "registerDemoAccount";
  constructor(
    public deviceId: string,
    public os: string,
    public osVersion: string,
    public msisdn: string,
    public email: string,
    public type: string,
    public countryCode: string,
    public tac: string,
    public ref: string
  ) {}
}
export class SetPaymentProvider {
  readonly method = "setPaymentProvider";
  constructor(
    public active: number,
    public config: any,
    public provider_id: string,
    public ref: string
  ) {}
}
export class GetPaymentProviders {
  readonly method = "getPaymentProviders";
  constructor(public ref: string) {}
}
export class GetTacDemoAccount {
  readonly method = "getTacDemoAccount";
  constructor(
    public countryCode: string,
    public msisdn: string,
    public ref: string
  ) {}
}

export class GetAdsProvidersMethod {
  readonly method = "getAdsProviders";
  constructor(public provider_id: string, public ref: string) {}
}

export class SetAdsProviderMethod {
  readonly method = "setAdsProvider";
  constructor(
    public provider_id: string,
    public config: any,
    public ref: string
  ) {}
}
export class GetBillingInfoMethod {
  readonly method = "getPaymentInfo";
  constructor(public ref: string) {}
}
export class GetInvoicesMethod {
  readonly method = "getInvoices";
  constructor(public ref: string) {}
}

export class SendBillingSubscription {
  readonly method = "subscribeToPlan";
  constructor(
    public phone: string,
    public name: string,
    public email: string,
    public card_token: string,
    public plan_id: string,
    public coupon?: string,
    public sub_main?: boolean,
    public lm_data?: any
  ) {}
}

export class SendCouponToServer {
  readonly method = "retrieveCoupon";
  constructor(public coupon_id: string, public plan_id: string) {}
}

export class AddNewCreditCard {
  readonly method = "createCard";
  constructor(public card_token: string) {}
}

export class SetDefaultCreditCard {
  readonly method = "setDefaultCard";
  constructor(public card_id: string) {}
}

export class DeleteCreditCard {
  readonly method = "deleteCard";
  constructor(public card_id: string) {}
}

export class SubscribeToAddons {
  readonly method = "subscribeToAddons";
  constructor(
    public plan_id: string,
    public sub_main: boolean,
    public coupon?: string
  ) {}
}

export class ChangePlanMethod {
  readonly method = "changePlan";
  constructor(
    public new_plan_id: string,
    public coupon?: string,
    public sub_main?: boolean
  ) {}
}

export class CancelStripeSubscription {
  readonly method = "cancelStripeSubscription";
  constructor(
    public all: boolean,
    public plan_id?: string,
    public reason?: string,
    public sub_main?: boolean,
    public cancel_quantity?: number
  ) {}
}
export class RevokeSubscription {
  readonly method = "revokeSubscription";
  constructor() {}
}

export class SetSignupPattern {
  readonly method = "setSignupPattern";
  constructor(
    public data: SignupPatternUI[],
    public operator: string,
    public ref: string
  ) {}
}
export class GetSignupPattern {
  readonly method = "getSignupPattern";
  readonly page_size = 24;
  constructor(public page_number: number, public ref: string) {}
}

export class AddBlacklist {
  readonly method = "addToBlacklist";
  constructor(
    public signups: string[],
    public chat_id: string,
    public ref: string
  ) {}
}
export class AddWhitelist {
  readonly method = "addToWhitelist";
  constructor(
    public signups: SignupPatternUI[],
    public chat_id: string,
    public ref: string
  ) {}
}
export class DeleteSignupPattern {
  readonly method = "deleteSignupPattern";
  constructor(
    public pattern: string[],
    public operator: string,
    public ref: string
  ) {}
}
export class DeleteWhitelist {
  readonly method = "removeFromWhitelist";
  constructor(
    public signups: string[],
    public chat_id: string,
    public ref: string
  ) {}
}
export class DeleteBlacklist {
  readonly method = "removeFromBlacklist";
  constructor(
    public signups: string[],
    public chat_id: string,
    public ref: string
  ) {}
}
export class GetAppChannelSettings {
  readonly method = "getAppChannelSettings";
  constructor(public ref: string) {}
}
export class SetAppChannelSettings {
  readonly method = "setAppChannelSettings";
  constructor(public whiteList_enabled: boolean, public ref: string) {}
}

export class UpdateCompanyDetails {
  readonly method = "updateAppInfo";
  constructor(
    public company_name: string,
    public company_official_name: string,
    public company_url: string,
    public deep_link_schema: string,
    public ref: string
  ) {}
}

export class GetMyBot {
  readonly method = "getMyBot";
  constructor(
    public bot_id: number,
    public owner: number,
    public ref: string
  ) {}
}
export class GetMyBots {
  readonly method = "getMyBots";
  constructor(public owner: number, public ref: string) {}
}
export class RemoveBot {
  readonly method = "removeBot";
  constructor(public user_id: string, public ref: string) {}
}
export class GetBotToken {
  readonly method = "getBotToken";
  constructor(
    public chat_id: string,
    public user_id: string,
    public ref: string
  ) {}
}
export class ViewBotToken {
  readonly method = "viewBotToken";
  constructor(
    public chat_id: string,
    public user_id: string,
    public ref: string
  ) {}
}
export class CreateBot {
  readonly method = "createBot";
  constructor(
    public name: string,
    public short_name: string,
    public reference: string
  ) {}
}

export class GetUserList {
  readonly method = "getUserList";
  readonly p = 1;
  constructor(public user_id: string[], public ref: string) {}
}
export class chatWithAI {
  readonly method = "chatWithAI";
  constructor(
    public prompt: string,
    public generate: boolean,
    public ref: string
  ) {}
}
export class SetBot {
  readonly method = "setBot";
  constructor(
    public id: string,
    public name: string,
    public short_name: string,
    public status: string,
    public about: string,
    public filter: number,
    public botType: string,
    public inline: number,
    public is_public: number,
    public is_published: number,
    public photo: Media,
    public paid: boolean,
    public product: Product[],
    public owner: number,
    public ref: string
  ) {}
}
export class PublishBot {
  readonly method = "publishBot";
  constructor(
    public id: string,
    public shortName: string,
    public ref: string
  ) {}
}
export class GetChatMember {
  readonly method = "getChatMember";
  constructor(
    public chat_id: string,
    public user_id: string,
    public ref: string
  ) {}
}
export class SetPrivileges {
  readonly method = "setPrivileges";
  constructor(
    public chat_id: string,
    public user_id: string,
    public privileges: string[],
    public ref: string
  ) {}
}

export class CancelMessageSchedule {
  readonly method = "cancelMessageSchedule";
  constructor(public message_id: string, public ref: string) {}
}

export class SetTax {
  readonly method = "setTax";
  constructor(public tax: any, public ref: string) {}
}
export class GetTax {
  readonly method = "getTax";
  constructor(public ref: string) {}
}

export class SetFee {
  readonly method = "setFee";
  constructor(public fee: any, public ref: string) {}
}
export class GetFee {
  readonly method = "getFee";
  constructor(public ref: string) {}
}

export class SetAppInfo {
  readonly method = "setAppInfo";
  constructor(public app_info: any, public ref: string) {}
}
export class GetAppInfo {
  readonly method = "getAppInfo";
  constructor(public ref: string) {}
}
export class SetShipping {
  readonly method = "setShipping";
  constructor(public shipping: any, public ref: string) {}
}
export class GetShipping {
  readonly method = "getShipping";
  constructor(public ref: string) {}
}

export class GetBotTemplates {
  readonly method = "getBotTemplates";
  constructor(public ref: string) {}
}
export class AddBot {
  readonly method = "addBot";
  constructor(public user_id: string, public ref: string) {}
}

export class SetMStore {
  readonly method = "setStore";
  constructor(
    public menu_id?: string,
    public currency?: string,
    public shop?: any,
    public image?: any,
    public name?: string,
    public description?: string,
    public id?: number,
    public is_default?: number,
    public category?: string,
    public ref?: string
  ) {}
}
export class DeleteMStore {
  readonly method = "deleteStore";
  constructor(public store_id: string[], public ref: string) {}
}
export class SetBranch {
  readonly method = "setBranch";
  constructor(branch: any, public ref?: string) {
    for (const key in branch) {
      if (branch.hasOwnProperty(key)) {
        this[key] = branch[key];
      }
    }
  }
}

export class ListBranch {
  readonly method = "listBranch";
  constructor(
    public page_number: number,
    public page_size: number,
    public ref?: string,
    public type?: string,
    public id?: string,
    public vendor_id?: string,
    public status?: string,
    public name?: string,
    public created_date?: any,
    public owner_id?: string,
  ) {}
}

export class GetBranch {
  readonly method = "getBranch";
  constructor(
    public id: number,
    public ref: string,
    public vendor_id?: any
  ) {}
}

export class DeleteBranch {
  readonly method = "deleteBranch";
  constructor(public id: number, public ref: string) {}
}

export class SetBranchUser {
  readonly method = "setBranchUser";
  constructor(
    public branch_id: string,
    public account_id: string,
    public permissions: string,
    public status: string,
    public access: number,
    public ref?: string
  ) {}
}

export class RemoveBranchUser {
  readonly method = "removeBranchUser";
  constructor(
    public account_id: string,
    public branch_id: string,
    public ref?: string
  ) {}
}

export class ListBranchUser {
  readonly method = "listBranchUser";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public branch_id: string,
    public ref: string,
    public account_id?: string,
    public name?: string,
    public status?: string,
    public role_id?: number,
    public created_date?: any
  ) {}
}

export class ListZones {
  readonly method = "listZones";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public ref: string,
    public region_id?: string,
    public status?: string
  ) {}
}

export class SetZone{
  readonly method = "setZone";
  constructor(
    zone: any,
    public ref?: string
  ){
    for (const key in zone) {
      if (zone.hasOwnProperty(key)) {
        this[key] = zone[key];
      }
    }
  }
}

export class GetZone {
  readonly method= "getZone";
  constructor(public id: string,public ref: string){}
}
export class DeleteZone {
  readonly method= "deleteZone";
  constructor(public id: string,public ref: string){}
}

export class GetStore {
  readonly method = "getStore";
  constructor(public id?: number, public category?: string) {}
}

export class GetChatAdministrators {
  readonly method = "getChatAdministrators";
  constructor(public chat_id: string, public ref: string) {}
}
export class GetAppConfigHistory {
  readonly method = "getAppConfigHistory";
  constructor(public id: string, public ref: string) {}
}
export class RemoveAppRelease {
  readonly method = "removeAppRelease";
  constructor(public id: string, public ref: string) {}
}

export class ListPoll {
  readonly method = "listPoll";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public chat_id: string,
    public ref: string,
    public id?: string,
    public status?: string,
    public name?: string,
    public created_date?: any
  ) {}
}

export class SetPoll {
  readonly method = "setPoll";
  constructor(
    public id?: number,
    public menu_id?: string,
    public name?: string,
    public menu?: any[],
    public type?: string,
    public result_type?: string,
    public expiry_date?: number
  ) {}
}
export class GetPoll {
  readonly method = "getPoll";
  constructor(public id: number) {}
}
export class DeletePoll {
  readonly method = "deletePoll";
  constructor(public id: number, public ref: string) {}
}

export class GetMyCallBacksStats {
  readonly method = "getMyCallbackStats";
  constructor(public message_id: string) {}
}

export class SetTemplateFunctionMethod {
  readonly method = "setTemplateFunction";
  constructor(
    public function_id?: any,
    public template_id?: any,
    public function_name?: string,
    public param?: any
  ) {}
}

export class SetAppConfigTemplate {
  readonly method = "setAppConfigTemplate";
  // readonly reference = CREATE_APP_TEMPLATE_REF;
  constructor(
    public reference: string,
    public id?: string,
    public name?: string,
    public category?: any,
    public appConfig?: any,
    public onlineAppConfig?: any,
    public onlineChannelConfig?: any
  ) {}
}

export class SetTemplateMessageMethod {
  readonly method = "setTemplateMessage";
  constructor(
    public function_id: any,
    public message_type: string,
    public message_id: string,
    public message: any,
    public template_id?: any
  ) {}
}

export class GetTemplateMethod {
  readonly method = "getTemplate";
  constructor(public template_id: any, public reference: any) {}
}

export class ManageAppMember {
  readonly method = "manageAppMember";
  constructor(public user_id: any, public op: any, public ref: string) {}
}
export class DeleteAppMember {
  readonly method = "deleteAppMember";
  constructor(public user_id: any, public ref: string) {}
}

export class RunAppConfigTemplate {
  readonly method = "runAppConfigTemplate";
  constructor(public template_id: any) {}
}

export class DeleteCoupon {
  readonly method = "deleteCoupon";
  constructor(public coupon_id: string, public reference: string) {}
}
export class RemoveCalendar {
  readonly method = "removeCalendar";
  constructor(public calendar_id: string, public reference: string) {}
}
export class SharePost {
  readonly method = "shareMessage";
  constructor(
    public from_user_id: string,
    public from_user_name: string,
    public message_id: string,
    public chat_id: string,
    public chat_name: string,
    public date: number,
    public text?: string,
    public attachment?: string
  ) {}
}

export class GetChatWithAI {
  readonly method = "getChatWithAI";
  constructor(public ref: string) {}
}

export class ResetAIChat {
  readonly method = "resetAIChat";
  constructor(public ref: string) {}
}
export class SetPollResult {
  readonly method = "setPollResult";
  constructor(
    public groupId: string,
    public menu: any,
    public message_ids?: any
  ) {}
}
export class PublishPollResult {
  readonly method = "publishPollResult";
  constructor(
    public groupId: string,
    public menu_group: string,
    public message?: any
  ) {}
}

export class MessageAI {
  readonly method = "messageAI";
  constructor(
    public prompt: string,
    public state: number,
    public remind: any,
    public ref: string
  ) {}
}

export class GetAIHistory {
  readonly method = "getAIHistory";
  constructor(public ref: string, public mainGroupId?: string) {}
}

export class ClearAIHistory {
  readonly method = "clearAIHistory";
  constructor(public ref: string) {}
}

export class GetAIDefinition {
  readonly method = "getAIDefinition";
  constructor(public state: number, public ref: string) {}
}

export class UpdateAIDefinition {
  readonly method = "updateAIDefinition";
  constructor(
    public state: number,
    public system_prompt: string,
    public schema: string,
    public model: string,
    public next_state_id: number,
    public json_key: string,
    public structure: string,
    public system_question: string,
    public logical_condition: string,
    public web: string,
    public parameters: string,
    public user_prompt: string,
    public output: string,
    public mode: string,
    public assistantId: string,
    public builder_state: string,
    public history_scope: string,
    public ref: string
  ) {}
}

export class GenerateAIApp {
  readonly method = "generateAIApp";
  constructor(
    public current_version: number,
    public app_ref: string,
    public ref: string
  ) {}
}

export class GenerateAIAppFromAITemplate {
  readonly method = "generateAIAppFromAITemplate";
  constructor(
    public id: any,
    public current_version: number,
    public app_ref: string,
    public ref: string
  ) {}
}

export class GetUsersPaymentOrders {
  readonly method = "getUsersPaymentOrders";
  readonly pageSize = 24;
  constructor(
    public page: number,
    public reference: string,
    public orderDate?: any,
    public status?: any,
    public accountId?: any,
    public paymentMethod?: any,
    public oid?: string,
    public senderId?: string,
    public receiverId?: string
  ) {}
}

export class ListOrderRequest {
  readonly method = "listOrderRequest";
  constructor(
    public ref: string,
    public page_number: number,
    public page_size: number,
    public branch_id?: number,
    public status?: string,
    public created_date?: string,
    public expire_date?: string
  ) {}
}

export class GetOrderRequest {
  readonly method = "getOrderRequest";
  constructor(
    public id: string,
    public date_month: number,
    public ref: string
  ) {}
}

export class ListOffers {
  readonly method = "listOffers";
  constructor(
    public rid: string,
    public date_month: number,
    public ref: string
  ) {}
}
export class SetOrderRequest {
  readonly method = "setOrderRequest";
  constructor(
    public rid: string,
    public date_month: number,
    public status: string,
    public ref: string
  ) {}
}

export class GetOrderDetails {
  readonly method = "getOrderDetails";
  constructor(
    public oid: string,
    public reference: string,
    public dateMonth?: any
  ) {}
}

export class GetMapMarkers {
  readonly method = "getMapMarkers";
  readonly page_size = 24;
  constructor(public page_number: number, public reference: string) {}
}

export class CreateMapMarker {
  readonly method = "createMapMarker";
  constructor(mapMarker: MapMarker, public reference: string) {
    for (const key in mapMarker) {
      if (mapMarker.hasOwnProperty(key)) {
        this[key] = mapMarker[key];
      }
    }
  }
}
export class SetMapMarker {
  readonly method = "setMapMarker";
  constructor(mapMarker: MapMarker, public reference: string) {
    for (const key in mapMarker) {
      if (mapMarker.hasOwnProperty(key)) {
        this[key] = mapMarker[key];
      }
    }
  }
}

export class GetMapMarker {
  readonly method = "getMapMarker";
  constructor(public id: string, public reference: string) {}
}

export class RemoveMapMarker {
  readonly method = "removeMapMarker";
  constructor(public id: string, public reference: string) {}
}

export class GetPollResult {
  readonly method = "getPollResult";
  constructor(public groupId: string, public menu_group: string) {}
}

export class SearchItems {
  readonly method = "searchItems";
  constructor(
    public query: any,
    public values: any,
    public action: string,
    public ref: string,
    public page_number: number,
    public page_size: number,
    public span_size: number,
    public api_id?: string,
    public style?: string
  ) {}
}

export class GreateArticle {
  readonly method = "createArticle";
  constructor(
    public title: string,
    public author: string,
    public content: string,
    public reference?: number
  ) {}
}
export class GetTagsValue {
  readonly method = "getTagsValue";
  constructor(
    public tags: { id: string; type: string; value: string[] }[],
    public reference?: number
  ) {}
}

export class SetSignupStatus {
  readonly method = "setSignupStatus";
  constructor(public status: string, public number?: number, public debug?: boolean) {}
}

export class ListPartners {
  readonly method = "listPartners";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public reference: string,
    public email?: string,
    public from_date?: any,
    public to_date?: any,
    public plan?: string
  ) {}
}

export class ListAppFunnel {
  readonly method = "listAppFunnel";
  readonly page_size = 24;
  constructor(
    public page_number: number,
    public ref: string,
    public app_id?: string,
    public email?: string,
    public from_date?: any,
    public to_date?: any,
    public country?: string,
    public converted_to_paid?: any,
    public filter_mode?: any
  ) {}
}
// Return the total signup, verified, activated, trails_started, converted
export class ListFunnelMetrics {
  readonly method = "listFunnelMetrics";
  readonly page_size = 36;
  constructor(
    public page_number: number,
    public ref: string,
    public type: string, // daily , weekly and monthly
    public from_date?: any,
    public to_date?: any
  ) {}
}
export class ListFunnelKpiSummary {
  readonly method = "listFunnelKpiSummary";
  readonly page_size = 36;
  constructor(
    public page_number: number,
    public ref: string,
    public type: string, // daily , weekly and monthly
    public from_date?: any,
    public to_date?: any
  ) {}
}
export class ListSignupSourceMetrics {
  readonly method = "listSignupSourceMetrics";
  readonly page_size = 36;
  constructor(
    public page_number: number,
    public ref: string,
    public type: string, // daily , weekly and monthly
    public from_date?: any,
    public to_date?: any
  ) {}
}

export class ListSignupConversionCohorts {
  readonly method = "listSignupConversionCohorts";
  readonly page_size = 36;
  constructor(
    public page_number: number,
    public ref: string,
    public from_date?: any,
    public to_date?: any
  ) {}
}
//

export class SetAppStats {
  readonly method = "setAppStats";
  constructor(public target: string, public platform?: string) {}
}
export class SetAppBuildRate {
  readonly method = "setAppBuildRate";
  constructor(public build_rate: number, public ref: string) {}
}
export class SetAppPaymentDate {
  readonly method = "setAppPaymentDate";
  constructor(
    public trial_end_date: string,
    public ref: string,
    public payment_date?: string
  ) {}
}
export class SendDeviceCalendar {
  readonly method = "sendDeviceCalendar";
  constructor(public ref: string) {}
}

export class GetCustomerToken {
  readonly method = "getCustomerToken";
  constructor(public su: string, public ref: string) {}
}

export class SetWorkflow {
  readonly method = "setWorkflow";
  constructor(
    public name: string,
    public module: string,
    public status: string,
    public module_id?: string,
    public workflow_id?: string,
    public task_id?: string,
    public schedule_cycle?: string,
    public schedule_min_after?: string,
    public schedule_hour?: string,
    public trigger_type?: string,
    public trigger_event?: string,
    public json?: any,
    public inquiry?: any,

  ) {}
}

export class ListWorkflow {
  readonly method = "listWorkflow";
  constructor(
    public page_number: number,
    public page_size: number,
    public ref: string,
    public id?: string,
    public status?: string,
    public created_date?: string,
    public name?: string
  ) {}
}

export class GetWorkflow {
  readonly method = "getWorkflow";
  constructor(public id: string, public ref: string) {}
}

export class DeleteWorkflow {
  readonly method = "deleteWorkflow";
  constructor(public id: string, public ref: string) {}
}

export class SetServiceOrderStatus {
  readonly method = "setServiceOrderStatus";
  constructor(
    public oid: string,
    public dateMonth: string,
    public status: string,
    public data?: any[],
    public reference?: string
  ) {}
}

export class CreateTeamAccount {
  readonly method = "createTeamAccount";
  constructor(
    public email: string,
    public password: string,
    public role_id: number,
    public full_name: string,
    public ref: string
  ) {}
}

export class SetTeamAccount {
  readonly method = "setTeamAccount";
  constructor(
    public accountId: string,
    public ref: string,
    public roleId: number
  ) {}
}

export class SetCustomSchema {
  readonly method = "setCustomSchema";
  constructor(
    public group_id: string,
    public name: string,
    public description: string,
    public type: string,
    public schema: any[],
    public menu_id: string,
    public menu_group: string,
    public id?: string,
    public status?: string,
    public ref?: string
  ) {}
}

export class SetContent {
  readonly method = "setContent";
  constructor(
    public id?: string,
    public name?: string,
    public description?: string,
    public type?: string,
    public keyword?: any[],
    public tag?: any[],
    public catalog?: any[],
    public status?: string,
    public schema_id?: string,
    public vendor?: string,
    public style?: string,
    public content?: any,
    public rank?: any,
    public custom_menu?: any,
    public ref?: string
  ) {}
}

export class GetCustomSchema {
  readonly method = "getCustomSchema";
  constructor(
    public group_id: string,
    public ref?: string,
    public id?: string,
    public type?: string
  ) {}
}

export class GetContent {
  readonly method = "getContent";
  constructor(public id: string, public ref: string) {}
}

export class DeleteCustomSchema {
  readonly method = "deleteCustomSchema";
  constructor(public group_id: string, public id: string) {}
}

export class DeleteContent {
  readonly method = "deleteContent";
  constructor(public group_id: string, public id: string, public ref: string) {}
}

export class ListCustomSchema {
  readonly method = "listCustomSchema";
  constructor(
    public group_id: string,
    public page: number,
    public page_size: number,
    public ref?: string,
    public id?: string,
    public name?: string,
    public type?: string,
    public created_date?: string
  ) {}
}

export class ListContent {
  readonly method = "listContent";
  constructor(
    public page: number,
    public page_size: number,
    public ref?: string,
    public name?: string,
    public id?: string,
    public created_date?: string,
    public type?: string,
    public status?: string
  ) {}
}

export class SetTopic {
  readonly method = "setTopic";
  constructor(public name: string, public ref: string) {}
}

export class DeleteTopic {
  readonly method = "deleteTopic";
  constructor(public id: string, public ref: string) {}
}

export class ListTopics {
  readonly method = "listTopics";
  constructor(
    public page: number,
    public pageSize: number,
    public ref: string,
    public name?: string,
    public id?: string,
    public created_date?: string
  ) {}
}

export class ListAppPermission {
  readonly method = "listAppPermission";
  constructor(
    public page: number,
    public pageSize: number,
    public ref: string
  ) {}
}

export class SetAppPermission {
  readonly method = "setAppPermission";
  constructor(
    public roleName: string,
    public permission: string,
    public ref: string,
    public roleId?: string
  ) {}
}

export class DeleteAppPermission {
  readonly method = "deleteAppPermission";
  constructor(public roleId: string, public ref: string) {}
}

export class GetTeamAccount {
  readonly method = "getTeamAccount";
  constructor(public accountId: string, public ref: string) {}
}
export class ListTeamAccount {
  readonly method = "listTeamAccount";
  constructor(public ref: string) {}
}
export class DeleteTeamAccount {
  readonly method = "deleteTeamAccount";
  constructor(public accountId: string, public ref: string) {}
}

export class SetETemplate {
  readonly method = "setETemplate";
  constructor(public id: string, public data: any, public ref: string) {}
}
export class SetSMSTemplate {
  readonly method = "setSMSTemplate";
  constructor(public id: string, public data: any, public ref: string) {}
}
export class SetMessageTemplate {
  readonly method = "setMessageTemplate";
  constructor(public id: string, public data: any, public ref: string) {}
}

export class GetETemplate {
  readonly method = "getETemplate";
  constructor(public id: string, public ref: string) {}
}
export class GetSMSTemplate {
  readonly method = "getSMSTemplate";
  constructor(public id: string, public ref: string) {}
}
export class GetMessageTemplate {
  readonly method = "getMessageTemplate";
  constructor(public id: string, public ref: string) {}
}

export class DeleteETemplate {
  readonly method = "deleteETemplate";
  constructor(public id: string, public ref: string) {}
}
export class DeleteSMSTemplate {
  readonly method = "deleteSMSTemplate";
  constructor(public id: string, public ref: string) {}
}
export class DeleteMessageTemplate {
  readonly method = "deleteMessageTemplate";
  constructor(public id: string, public ref: string) {}
}

export class ListETemplates {
  readonly method = "listETemplates";
  constructor(
    public page: number,
    public pageSize: number,
    public ref: string,
    public name?: string,
    public id?: string,
    public created_date?: string
  ) {}
}
export class ListSMSTemplate {
  readonly method = "listSMSTemplate";
  constructor(
    public page: number,
    public pageSize: number,
    public ref: string,
    public name?: string,
    public id?: string,
    public created_date?: string
  ) {}
}

export class ListMessageTemplate {
  readonly method = "listMessageTemplate";
  constructor(
    public page: number,
    public pageSize: number,
    public ref: string,
    public name?: string,
    public id?: string,
    public created_date?: string
  ) {}
}

export class SetNotificationTemplate {
  readonly method = "setNotificationTemplate";
  constructor(public id: string, public data: any, public ref: string) {}
}

export class GetNotificationTemplate {
  readonly method = "getNotificationTemplate";
  constructor(public id: string, public ref: string) {}
}

export class GetNotification {
  readonly method = "getNotification";
  constructor(public id: string, public ref: string) {}
}

export class DeleteNotificationTemplate {
  readonly method = "deleteNotificationTemplate";
  constructor(public id: string, public ref: string) {}
}

export class ListNotificationTemplates {
  readonly method = "listNotificationTemplates";
  constructor(
    public page: number,
    public pageSize: number,
    public ref: string,
    public name?: string,
    public id?: string,
    public created_date?: string
  ) {}
}

export class ListNotifications {
  readonly method = "listNotifications";
  constructor(
    public page: number,
    public pageSize: number,
    public ref: string,
    public name?: string,
    public id?: string,
    public created_date?: string
  ) {}
}

export class DeleteNotification {
  readonly method = "deleteNotificationsFromHistory";
  constructor(public id: string[], public ref: string) {}
}

export class ListAITemplates {
  readonly method = "listAITemplates";
  constructor(
    public page: number,
    public pageSize: number,
    public ref: string,
    public name?: string,
    public id?: string,
    public created_date?: string
  ) {}
}

export class GetMyProfiles {
  readonly method = "getMyProfiles";
  constructor(public reference: string) {}
}
export class UpdateMyAccount {
  readonly method = "updateMyAccount";
  constructor(
    public full_name?: string,
    public status?: string,
    public url?: string,
    public ref?: string
  ) {}
}
export class SendEmail {
  readonly method = "sendEmail";
  constructor(
    public account_id: string,
    public data: any,
    public ref: string
  ) {}
}

export class ListEmails {
  readonly method = "listEmails";
  constructor(
    public page: number,
    public page_size: number,
    public ref: string
  ) {}
}

export class GetEmail {
  readonly method = "getEmailDetails";
  constructor(public email_id: string, public ref: string) {}
}
export class RemoveEmail {
  readonly method = "deleteEmailsFromHistory";
  constructor(public email_ids: string[], public ref: string) {}
}
export class SetCollectionContent {
  readonly method = "setCatalog";
  constructor(
    public id?: string,
    public name?: string,
    public description?: string,
    public image?: ProductImage[],
    public style?: string,
    public status?: string,
    public content?: any[],
    public rank?: any,
    public custom_menu?: any[],
    public tag?: any[],
    public ref?: string
  ) {}
}
export class GetCollectionContent {
  readonly method = "getCatalog";
  constructor(public id: string, public ref: string) {}
}

export class ListCatalogContent {
  readonly method = "listCatalog";
  constructor(
    public page: number,
    public page_size: number,
    public ref?: string,
    public name?: string,
    public id?: string,
    public created_date?: string
  ) {}
}

export class DeleteCatalog {
  readonly method = "deleteCatalog";
  constructor(public id: string, public ref: string) {}
}

export class StartAIBuilder {
  readonly method = "startAIBuilder";
  constructor(
    public module: string,
    public module_id: string,
    public status: string,
    public ref: string,
    public data?: any
  ) {}
}

export class MessageAIModule {
  readonly method = "messageAIModule";
  constructor(
    public prompt: string,
    public state: number,
    public module: string,
    public module_id: string,
    public ref: string,
    public remind?: boolean,
    public no_save?: boolean,
    public images?: string[]
  ) {}
}

export class Maintenance {
  readonly method = "maintenance";
  constructor(
    public account_id: string,
    public operator: string,
    public ref: string,
    public build_rate?: number,
    public new_email?: string,
    public new_plan?: string,
    public custom_block?: any
  ) {}
}

export class SetProfile {
  readonly method = "setProfile";
  constructor(public user: any) {}
}

export class SendSms {
  readonly method = "sendSms";
  constructor(
    public account_id: string,
    public message: string,
    public provider_id: any,
    public ref: string
  ) {}
}

export class ListSms {
  readonly method = "listSms";
  constructor(
    public page: number,
    public pageSize: number,
    public ref: string
  ) {}
}

export class GetSms {
  readonly method = "getSmsDetails";
  constructor(public sms_id: string, public ref: string) {}
}

export class RemoveSms {
  readonly method = "deleteSmsFromHistory";
  constructor(public sms_ids: string[], public ref: string) {}
}

export class ListRequestsToCheck {
  readonly method = "listRequestsToCheck";
  readonly page_size = 24;
  constructor(
    public page: number,
    public ref: string,
    public id?: any,
    public status?: string,
    public created_date?: string,
    public check_date?: string,
    public maker_id?: any
  ) {}
}
export class ProcessMakerCheckerRecord {
  readonly method = "processMakerCheckerRecord";
  constructor(
    public status: string,
    public request_id: any,
    public ref: string,
    public maker_id?: string
  ) {}
}

export class ApiRemoveChatTags {
  readonly method = "removeChatTags";

  constructor(
    public tag_id: string,
    public chat_id: string,
    public ref: string
  ) {}
}

export class DeleteTemplatePosts {
  readonly method = "deleteTemplatePosts";
  constructor(public templateId: string) {}
}

export class DeleteTemplateAll {
  readonly method = "deleteTemplateAll";
  constructor(public templateId: string) {}
}
export class GetReviews {
  readonly method = "getReviews";
  readonly page_size = 24;
  constructor(
    public entity_id: string,
    public entity_type: string,
    public page_number: number,
    public ref: string
  ) {}
}

export class SetReviewStatus {
  readonly method = "setReviewStatus";
  constructor(
    public entity_id: string,
    public entity_type: string,
    public status: string,
    public account_id: string,
    public ref: string,
    public date_month: number
  ) {}
}

export class GetMediaFile {
  readonly method = "getMediaFile";
  constructor(public filename: string) {}
}
export class GetArticle {
  readonly method = "getArticle";
  constructor(public id: string) {}
}
export class SendNotification {
  readonly method = "sendNotification";
  constructor(
    public data?: {
      image?: any;
      name?: string;
      title?: string;
      message?: string;
    },
    public account_id?: string,
    public topic?: string,
    public ref?: string
  ) {}
}

export class SetCategory {
  readonly method = "setCategory";
  constructor(
    public name?: string,
    public parent_id?: string,
    public type?: string,
    public id?: string,
    public ref?: string
  ) {}
}

export class GetCategory {
  readonly method = "getCategory";
  constructor(public id: string, public ref: string) {}
}

export class ListCategory {
  readonly method = "listCategory";
  constructor(
    public page_number?: number,
    public page_size?: number,
    public ref?: string,
    public name?: string,
    public parent_id?: string,
    public type?: string,
  ) {}
}

export class DeleteCategory {
  readonly method = "deleteCategory";
  constructor(public id: string, public ref: string) {}
}

export class ListAccountMenu {
  readonly method = "listAccountMenu";
  constructor(
    public page_number?: number,
    public page_size?: number,
    public ref?: string,
    public status?: string,
    public menu_id?: string,
    public menu_group?: string,
    public account_id?: string
  ) {}
}

export class GetAccountMenu {
  readonly method = "getAccountMenu";
  constructor(
    public ref?: string,
    public account_id?: string,
    public menu_id?: string,
    public menu_group?: string
  ) {}
}

export class DeleteAccountMenu {
  readonly method = "changeStatusAccountMenu";
  constructor(
    public callback?: string,
    public account_id?: string,
    public menu_id?: string,
    public ref?: string
  ) {}
}
